import { Component, Show, createEffect, createSignal, onMount } from "solid-js";
import { A, FormError } from "solid-start";
import { createServerAction$, redirect } from "solid-start/server";
import { notify } from "~/components/global/Notification";
import Icons from "~/components/icons/Icons";
import AuthLayout from "~/components/layouts/auth.layout";
import blurInput from "~/directives/blur-input.directive";
import messages from "~/helpers/message";
import { validateEmail } from "~/helpers/validators";
import fetchApi from "~/lib/api";

const inputLbl = blurInput;

const forgotPassword: Component = () => {
  const [passwordResetingIn, { Form }] = createServerAction$(
    async (form: FormData, { request }) => {
      const email = form.get("email") as string;
      if (typeof email !== "string") {
        throw new FormError(`Form not submitted correctly.`);
      }

      const fields = { email: email.trim() };
      let fieldErrors: any = {
        email: validateEmail(email.trim()),
      };
      if (Object.values(fieldErrors).some(Boolean)) {
        if (fieldErrors?.email) {
          throw new FormError("", { fieldErrors, fields });
        } else {
          throw new FormError("", { fieldErrors, fields });
        }
      }

      const apiParams: any = {
        method: "POST" as string,
        url: `${import.meta.env.VITE_API_URL}/user/password/forgot`,
        jwt_token: "",
        body: fields,
      };
      const updateProfile = await fetchApi(apiParams);
      if (
        updateProfile?.statusCode == 401 ||
        updateProfile?.statusCode == 403
      ) {
        throw redirect("/logout");
      }
      if (updateProfile && updateProfile.status) {
        switch (updateProfile.message) {
          case "USER_PASSWORD_RESET_MAIL_SENT_SUCCESS":
            return "success";
          default:
            return "error";
        }
      } else {
        switch (updateProfile.message) {
          case "USER_NOT_VALID":
            return "warn";
          default:
            return "error";
        }
      }
    }
  );

  createEffect(() => {
    if (passwordResetingIn.result) {
      const predictResult: any = {
        success: {
          res: messages.user.USER_PASSWORD_RESET_MAIL_SENT_SUCCESS,
          theme: "success",
        },
        error: {
          res: messages.error.USER_PASSWORD_RESET_MAIL_SENT_ERROR,
          theme: "danger",
        },
        warn: {
          res: messages.warn.USER_NOT_VALID,
          theme: "warm",
        },
      };
      notify({
        isNotified: true,
        message: predictResult[passwordResetingIn.result].res as string,
        theme: predictResult[passwordResetingIn.result].theme as string,
        placement: "top",
        timeout: 2500,
      });
    }
  });

  return (
    <AuthLayout size="md">
      <Form class="auth-form">
        <h2 class="title flex align-center justify-center auth-form__title">
          &nbsp;Reset Password
        </h2>
        <div class="clearfix"></div>
        <br />
        <div class="form-group icon-group">
          <span class="form-group__icon">
            <Icons name="email" width={18} height={18} />
          </span>
          <div class="form-element">
            <input
              id="email-input"
              name="email"
              field-label="Email Address"
              class={`input ${
                passwordResetingIn.error?.fieldErrors?.email
                  ? "error-input"
                  : ""
              }`}
              use:inputLbl
            />
          </div>
        </div>
        <Show when={passwordResetingIn.error?.fieldErrors?.email}>
          <p class="error-message" role="alert">
            {passwordResetingIn.error.fieldErrors.email}
          </p>
        </Show>
        <div class="clearfix"></div>
        <br />
        <div class="text-center">
          <button class="btn primary" type="submit">
            Reset Password
          </button>
        </div>
        <div class="clearfix"></div>
        <p class="text-gray fw-500">
          <A class="a-link" href="/login">
            Back to login
          </A>
        </p>
      </Form>
    </AuthLayout>
  );
};

export default forgotPassword;
